import React from 'react';
import { createRoot } from 'react-dom/client';


import ErrorBoundary from './components/ErrorBoundary.js';
import Alert from './components/Alert.js';
import BecomePaidMemberModal from './components/BecomePaidMemberModal.js';
import UpdateSubscriptionModal from "./components/UpdateSubscriptionModal.js";
import StripeOKCancelModal from './components/StripeOKCancelModal.js';
import CancelSubscriptionModal from './components/CancelSubscriptionModal.js';
import NewsletterUnsubscribeModal from './components/NewsletterUnsubscribeModal.js';


import StaticPriceCards from './components/StaticPriceCards.js';
import ModalPriceCards from './components/ModalPriceCards.js';
import UserAccountDrawer from './components/UserAccountDrawer.js';

import MobileNav from './components/MobileNav.js';

import { member_logout } from './api/api_calls.js';

window.member_logout = member_logout;

let SERVER_URL = null;
if(process.env.NODE_ENV === 'development'){
    SERVER_URL = "http://localhost:8787/"; //checkout server local"
}else{
   SERVER_URL = "https://skeptic_stripe_checkout.tomravn.workers.dev/"; //dev 
}

const ALLOWED_PLANS = [
    {name: 'The Free Thinker', interval:'forever'}, 
    {name: 'The Deep Thinker', interval:'month'}, 
    {name: 'The Deep Thinker Plus', interval:'year'}, 
    {name: 'The Thought Leader', interval:'year'}
];


//INIT Different React APPs
const reactRootElementStaticPriceCards = document.getElementById('react-app-static-plans');
const reactRootModals = document.getElementById('react-app-modals');

if (reactRootElementStaticPriceCards) {
    const root = createRoot(reactRootElementStaticPriceCards);
    root.render(
    <ErrorBoundary>
        <StaticPriceCards api_server_url={SERVER_URL} ALLOWED_PLANS={ALLOWED_PLANS} />
    </ErrorBoundary>
    );
}

if(reactRootModals){
    const root = createRoot(reactRootModals);
    root.render(   
    <>
    <BecomePaidMemberModal api_server_url={SERVER_URL}/>
    <UpdateSubscriptionModal api_server_url={SERVER_URL}/>
    <StripeOKCancelModal/>
    <UserAccountDrawer api_server_url={SERVER_URL} ALLOWED_PLANS={ALLOWED_PLANS}/>
    <CancelSubscriptionModal api_server_url={SERVER_URL}/>
    <Alert/>
    <ModalPriceCards api_server_url={SERVER_URL} ALLOWED_PLANS={ALLOWED_PLANS}/>
    <MobileNav/>
    <NewsletterUnsubscribeModal/>
    </>
    )
}








